import React from 'react';
import { Menu } from 'antd';
import { useNavigate } from 'react-router-dom';

interface NavigationMenuProps {
  menuItems: any[];
  selectedKey: string[];
  openKey: string[];
  backgroundColor: string;
  onItemClick?: () => void;
  /** 'dark' | 'light' — por defecto 'dark' (compat). Pasar según el tema activo. */
  mode?: 'dark' | 'light';
}

export const NavigationMenu: React.FC<NavigationMenuProps> = ({
  menuItems,
  selectedKey,
  openKey,
  backgroundColor,
  onItemClick,
  mode = 'dark',
}) => {
  const navigate = useNavigate();

  return (
    <Menu
      theme={mode}
      mode="inline"
      selectedKeys={selectedKey}
      defaultOpenKeys={openKey}
      items={menuItems}
      onClick={({ key }) => {
        if (key !== 'local-group' && key !== 'global-group') {
          navigate(key);
          if (onItemClick) onItemClick();
        }
      }}
      style={{ borderRight: 0, background: backgroundColor }}
    />
  );
};
